<template>
  <q-page padding>
    <PageHeader
      title="Listagem de Reserva de Ferramentas"
      :backRoute="{ name: 'ferramentaria-lista-reserva' }"
      backBehavior="route"
    />
    <div class="row col-12 q-mt-md q-gutter-sm text-brand-5 text-weight-bold">
      <div class="col-md-2 col-xs">
        <div class="texto-titulo-input">Unidade</div>
        <ListaUnidadesSelect />
      </div>
      <div class="col-md-2 col-xs">
        <div class="texto-titulo-input">Nome do Requisitante</div>
        <SelecaoFuncionario
          @emitirFuncionario="receberFuncionario"
          :resetar="resetarFuncionario"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 items-center q-mb-sm">
        <div
          class="row col-12 q-ml-md text-brand-5 text-weight-bold q-mb-md titulo-tabela"
        >
          Selecione as Ferramentas que Deseja Retirar
        </div>
        <div class="row col-12">
          <ComponenteFiltros
            :codigo="true"
            :classCodigo="'col-md col-xs-6'"
            :descricao="true"
            :classDescricao="'col-md col-xs-5'"
            :classGrupo="'col-md col-xs-6'"
            :subgrupo="true"
            :classSubgrupo="'col-md col-xs-5'"
            @enviarFiltro="receberFiltro"
          />
        </div>
      </div>
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        :columns="columns"
        :rows="listaItensCatalogo"
        flat
        dense
        :hide-bottom="!listaItensCatalogo.length == 0"
        no-data-label="Nenhuma ferramenta encontrada."
        selection="multiple"
        v-model:selected="selected"
        row-key="uuid"
        :class="{ 'my-sticky-dynamic': !mobile }"
        :rows-per-page-options="[0]"
        :grid="mobile"
      >
        <template v-slot:item="props">
          <div class="row col-12">
            <q-card
              @click="props.selected = !props.selected"
              class="container-grid-table row col-12 q-mt-sm"
              :style="
                props.selected
                  ? 'transform: scale(0.98); background: #b7cdf6'
                  : ''
              "
            >
              <div class="row col-12 items-center q-pa-sm">
                <div class="col-8">
                  <div class="row col-12">
                    <strong class="q-mr-xs">Código:</strong>
                    <span> {{ props.row.codigo }}</span>
                  </div>
                  <div class="row col-12">
                    <strong class="q-mr-xs">Descrição:</strong>
                    <span> {{ props.row.descricao }}</span>
                  </div>
                  <div class="row col-12">
                    <strong class="q-mr-xs">Grupo:</strong>
                    <span> {{ props.row.grupo.nome }}</span>
                  </div>
                  <div class="row col-12">
                    <strong class="q-mr-xs">Subgrupo:</strong>
                    <span> {{ props.row.subgrupo.nome }}</span>
                  </div>
                  <div class="row col-12">
                    <div
                      v-if="props.row?.atributos?.length > 0"
                      class="row col-12"
                    >
                      <span class="q-mr-sm"
                        ><strong>Chave: </strong
                        >{{ props.row?.atributos[0].chave }}</span
                      >
                      <span
                        ><strong>Valor: </strong
                        >{{ props.row?.atributos[0].valor
                        }}<span v-if="props.row?.atributos?.length > 1"
                          >....</span
                        ></span
                      >
                      <q-tooltip v-if="props.row?.atributos?.length > 1">
                        <div
                          v-for="(atributo, index) in props.row.atributos"
                          :key="index"
                        >
                          <div class="row col-12" v-if="atributo.valor">
                            <div class="row col-12 justify-between">
                              <span class="q-mr-sm"
                                >Chave: {{ atributo.chave }}
                              </span>
                              <span>Valor: {{ atributo.valor }}</span>
                            </div>
                          </div>
                        </div>
                      </q-tooltip>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row col-12 justify-end items-center">
                    <div class="q-mr-sm">
                      <div
                        style="
                          border: 1px solid #707070;
                          height: 60px;
                          width: 60px;
                          border-radius: 5px;
                          background-color: white;
                        "
                        class="items-center row col justify-center"
                      >
                        <q-img
                          v-if="props.row.url"
                          fit="contain"
                          height="100%"
                          width="95%"
                          :src="props.row.url"
                        />
                        <q-img
                          v-else
                          fit="contain"
                          height="100%"
                          width="95%"
                          src="../../../assets/semImagem.jpg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td class="coluna-selecionar">
              <q-btn
                round
                size="10px"
                :icon="props.selected ? 'close' : 'add'"
                :color="props.selected ? 'red' : 'secondary'"
                @click="props.selected = !props.selected"
                :disable="disable"
              />
            </q-td>
            <q-td>
              {{ props.row.codigo }}
            </q-td>
            <q-td>
              {{ props.row.descricao }}
            </q-td>
            <q-td>
              {{ props.row.grupo?.nome }}
            </q-td>
            <q-td>
              {{ props.row.subgrupo?.nome }}
            </q-td>
            <q-td>
              <div v-if="props.row?.atributos?.length > 0">
                <div>
                  <span class="q-mr-xs"
                    >Chave: {{ props.row?.atributos[0].chave }}
                  </span>
                  <span> Valor: {{ props.row?.atributos[0].valor }}</span>
                  <span v-if="props.row?.atributos?.length > 1">....</span>
                </div>
                <q-tooltip v-if="props.row?.atributos?.length > 1">
                  <div
                    v-for="(atributo, index) in props.row.atributos"
                    :key="index"
                  >
                    <div class="row col-12" v-if="atributo.valor">
                      <div class="row col-12 justify-between">
                        <span class="q-mr-sm"
                          >Chave: {{ atributo.chave }}
                        </span>
                        <span> Valor: {{ atributo.valor }}</span>
                      </div>
                    </div>
                  </div>
                </q-tooltip>
              </div>
              <div v-else>Sem Atributos</div>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div
        v-if="listaItensCatalogo.length > 0"
        class="row justify-center q-mt-md"
      >
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 justify-between items-center q-mb-sm">
        <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
          Ferramentas Selecionadas
        </div>
        <div class="row col-md-3 col-xs-12 justify-end">
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            type="text"
            class="col-md col-xs-7 input"
            placeholder="Pesquisar"
            v-model="filtroSelecionado"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-table
        :columns="columns"
        :rows="listaSelecionados"
        flat
        dense
        :hide-bottom="!listaSelecionados.length == 0"
        no-data-label="Nenhuma ferramenta selecionada."
        :class="{ 'my-sticky-dynamic': !mobile }"
        :rows-per-page-options="[0]"
        :grid="mobile"
      >
        <template v-slot:item="props">
          <div class="row col-12">
            <q-card
              @click="removerFerramenta(props.row.uuid)"
              class="container-grid-table row col-12 q-mt-sm bg-grey-3"
              style="transform: scale(0.98); background: #21386482"
            >
              <div class="row col-12 items-center q-pa-sm">
                <div class="col-10">
                  <div class="row col-12">
                    <strong class="q-mr-xs">Código:</strong>
                    <span> {{ props.row.codigo }}</span>
                  </div>
                  <div class="row col-12">
                    <strong class="q-mr-xs">Descrição:</strong>
                    <span> {{ props.row.descricao }}</span>
                  </div>
                  <div class="row col-12">
                    <strong class="q-mr-xs">Grupo:</strong>
                    <span> {{ props.row?.grupo?.nome }}</span>
                  </div>
                  <div class="row col-12">
                    <strong class="q-mr-xs">Subgrupo:</strong>
                    <span> {{ props.row?.subgrupo?.nome }}</span>
                  </div>
                  <div class="row col-12">
                    <div
                      v-if="props.row?.atributos?.length > 0"
                      class="row col-12"
                    >
                      <span class="q-mr-sm"
                        ><strong>Chave: </strong
                        >{{ props.row?.atributos[0].chave }}</span
                      >
                      <span
                        ><strong>Valor: </strong
                        >{{ props.row?.atributos[0].valor
                        }}<span v-if="props.row?.atributos?.length > 1"
                          >....</span
                        ></span
                      >
                      <q-tooltip v-if="props.row?.atributos?.length > 1">
                        <div
                          v-for="(atributo, index) in props.row.atributos"
                          :key="index"
                        >
                          <div class="row col-12" v-if="atributo.valor">
                            <div class="row col-12 justify-between">
                              <span class="q-mr-sm"
                                >Chave: {{ atributo.chave }}
                              </span>
                              <span>Valor: {{ atributo.valor }}</span>
                            </div>
                          </div>
                        </div>
                      </q-tooltip>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row col-12 justify-end items-center">
                    <div class="q-mr-sm">
                      <div
                        style="
                          border: 1px solid #707070;
                          height: 60px;
                          width: 60px;
                          border-radius: 5px;
                          background-color: white;
                        "
                        class="items-center row col justify-center"
                      >
                        <q-img
                          v-if="props.row.url"
                          fit="contain"
                          height="100%"
                          width="95%"
                          :src="props.row.url"
                        />
                        <q-img
                          v-else
                          fit="contain"
                          height="100%"
                          width="95%"
                          src="../../../assets/semImagem.jpg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td class="coluna-selecionar">
              <q-btn
                color="red"
                round
                icon="close"
                size="10px"
                :disable="disable"
                @click="removerFerramenta(props.row.uuid)"
              />
            </q-td>
            <q-td>
              {{ props.row.codigo }}
            </q-td>
            <q-td>
              {{ props.row.descricao }}
            </q-td>
            <q-td>
              {{ props.row?.grupo?.nome }}
            </q-td>
            <q-td>
              {{ props.row?.subgrupo?.nome }}
            </q-td>
            <q-td>
              <div v-if="props.row?.atributos?.length > 0">
                <div>
                  <span class="q-mr-xs"
                    >Chave: {{ props.row?.atributos[0].chave }}
                  </span>
                  <span> Valor: {{ props.row?.atributos[0].valor }}</span>
                  <span v-if="props.row?.atributos?.length > 1">....</span>
                </div>
                <q-tooltip v-if="props.row?.atributos?.length > 1">
                  <div
                    v-for="(atributo, index) in props.row.atributos"
                    :key="index"
                  >
                    <div class="row col-12" v-if="atributo.valor">
                      <div class="row col-12 justify-between">
                        <span class="q-mr-sm"
                          >Chave: {{ atributo.chave }}
                        </span>
                        <span> Valor: {{ atributo.valor }}</span>
                      </div>
                    </div>
                  </div>
                </q-tooltip>
              </div>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <div class="q-mt-xl q-ml-sm container-btn">
      <q-btn
        label="Criar Reserva"
        icon="done"
        color="positive"
        class="btn"
        no-caps
        @click="criarReserva()"
      />
    </div>
  </q-page>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";
import { watchDebounced } from "@vueuse/core";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelecaoFuncionario from "../components/SelecaoFuncionario.vue";
import ComponenteFiltros from "../components/ComponenteFiltros.vue";
import PageHeader from "../../../components/PageHeader.vue";

const columns = [
  {
    name: "selecionar",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descrição",
    label: "Descrição",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
  },
  {
    name: "atributo",
    label: "Atributos",
    align: "left",
  },
];

const columns2 = [
  {
    name: "remover",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descrição",
    label: "Descrição",
    align: "left",
  },
  {
    name: "valor",
    label: "Valor",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
  },
  {
    name: "atributo",
    label: "Atributos",
    align: "left",
  },
];

export default {
  components: {
    ListaUnidadesSelect,
    SelecaoFuncionario,
    ComponenteFiltros,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();

    const listaItensCatalogo = ref([]);
    const dados = ref({
      dadosRequisitante: {
        id: "",
        nome: "",
        matricula: "",
        biometria: "",
      },
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const resetarFuncionario = ref(0);
    const selected = ref([]);
    const filtroSelecionado = ref("");
    const listaSelecionados = ref([]);
    const catalogoUuid = salvarCatalogoUuid();
    const filtros = ref({});
    let disable = ref(false);
    let loading = ref(false);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarItensCatalogo = async (page = 0, perPage = 10) => {
      if (catalogoUuid.catalogoUuid.value === null) {
        listaItensCatalogo.value = [];
        return;
      }
      if (
        dados.value.dadosRequisitante.id === "" ||
        dados.value.dadosRequisitante.id === undefined
      ) {
        listaItensCatalogo.value = [];
        return;
      }
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarFerramentas",
          {
            perPage: perPage,
            page: page,
            codigo: filtros.value?.codigo,
            catalogoUuid: catalogoUuid.catalogoUuid.value,
            catalogoSubGrupoUuid: filtros.value.subgrupo?.catalogoSubGrupoUuid,
            nome: filtros.value?.descricao,
            nomeGrupo: filtros.value?.grupo?.nome,
            comAtributos: "sim",
            nomeSubgrupo: filtros.value?.grupo?.nome
              ? filtros.value?.subgrupo?.nome
              : "",
          }
        );
        listaItensCatalogo.value = response.listaFerramentas;
        pagination.value.page = response.response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.response.data.resultado.total;
        pagination.value.rowsPerPage = response.response.data.resultado.perPage;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
        disable.value = false;
        loading.value = false;
      }
    };
    const removerFerramenta = (uuid) => {
      selected.value = selected.value.filter(
        (ferramenta) => ferramenta.uuid != uuid
      );
    };

    const receberFuncionario = (value) => {
      if (value === null) {
        dados.value.dadosRequisitante = {
          id: "",
          nome: "",
          matricula: "",
          biometria: "",
        };
        return;
      }
      dados.value.dadosRequisitante = {
        id: value.id,
        nome: value.nome,
        matricula: value.matricula,
        biometria: value.biometria,
      };
    };

    const criarReserva = async () => {
      if (dados.value.dadosRequisitante.id === "") {
        quasar.notify({
          message: "Selecione um requisitante.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (selected.value.length === 0) {
        quasar.notify({
          message: "Selecione ao menos uma ferramenta.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      disable.value = true;
      let itens = [];
      selected.value.forEach((item) => {
        itens.push({ catalogoItemUuid: item.uuid });
      });
      try {
        await store.dispatch("ferramentaria/adicionarReserva", {
          unidadeId: store.state.org.unidadeData.id,
          solicitanteId: dados.value.dadosRequisitante.id,
          almoxRequisitanteNome: store.state.autenticacao.usuarioLogado.nome,
          solicitanteNome: dados.value.dadosRequisitante.nome,
          catalogoItens: itens,
        });
        quasar.notify({
          message: "Reserva criada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        router.push({ name: "ferramentaria-lista-reserva" });
      } catch (error) {
        console.log(error);
      }
    };

    const receberGrupoFiltro = (value) => {
      if (value === null || value === undefined) {
        filtros.value.grupo = "";
        return;
      }
      filtros.value.grupo = value;
    };

    const receberSubgrupoFiltro = (value) => {
      if (value === null || value === undefined) {
        filtros.value.subgrupo = "";
        return;
      }
      filtros.value.subgrupo = value;
    };

    const receberFiltro = (value) => {
      filtros.value = value;
      listarItensCatalogo();
    };

    const filtrarSelecionados = () => {
      listaSelecionados.value = selected.value.filter(
        (ativo) =>
          ativo?.codigo
            .toLowerCase()
            .includes(filtroSelecionado.value.toLowerCase()) ||
          ativo?.descricao
            .toLowerCase()
            .includes(filtroSelecionado.value.toLowerCase())
      );
    };

    watch(
      () => catalogoUuid.catalogoUuid.value,
      () => {
        dados.value.dadosRequisitante = {
          id: "",
          nome: "",
          matricula: "",
          biometria: "",
        };
      }
    );

    watch(
      () => dados.value.dadosRequisitante.id,
      () => {
        listarItensCatalogo();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarItensCatalogo(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    watchDebounced(
      [
        () => filtros.value.codigo,
        () => filtros.value.descricao,
        () => filtros.value.subgrupo,
      ],
      () => {
        listarItensCatalogo();
      },
      { debounce: 400 }
    );

    watch(
      () => filtroSelecionado.value,
      () => {
        filtrarSelecionados();
      }
    );

    watch(
      () => selected.value,
      () => {
        filtroSelecionado.value = "";
        listaSelecionados.value = [...selected.value];
      }
    );

    return {
      columns,
      columns2,
      listaItensCatalogo,
      receberFuncionario,
      resetarFuncionario,
      selected,
      removerFerramenta,
      criarReserva,
      disable,
      mobile,
      receberFiltro,
      loading,
      catalogoUuid,
      filtrarSelecionados,
      filtros,
      filtroSelecionado,
      listaSelecionados,
      receberGrupoFiltro,
      receberSubgrupoFiltro,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
tbody tr td {
  white-space: pre-wrap;
}
tbody tr .coluna-selecionar {
  width: 40px !important;
  margin: 0px;
  padding: 3px 2px;
}
tbody tr .coluna-atributo {
  width: 250px !important;
}
.texto-titulo {
  font-size: 20px;
}
.icon-voltar {
  font-size: 25px;
}
.container-link-voltar {
  margin-right: 10px;
}
.titulo-tabela {
  font-size: 18px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
@media (max-width: 600px) {
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
  .container-btn {
    margin: 20px 0px 15px 4px;
  }
  .btn {
    font-size: 13px;
  }
}
</style>
